import { defineMessages } from 'react-intl'

const messages = defineMessages({
  expiresOn: {
    id: 'global.card-expiration',
  },
})

export default messages
